import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import GenericListPair from 'modules/common/components/GenericListPair';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import useDebounce from 'modules/common/components/UseDebounce';
import ProvinceContent from './ProvinceContent';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
};

function ProvinceContainer({
  match,
  isLoading,
  history,
  getProvinceList,
  provinceList,
  provinceListPager,
  getRegionsList,
  regionsList,
}) {
  const [formData, setFormData] = useState(form);
  const [region, setRegion] = useState({
    label: '',
    value: 0,
  });

  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSelect = (e) => {
    setRegion(e);
    getProvinceList({ region_code: e.value });
  };

  useEffect(() => {
    getProvinceList({ region_code: region.value, isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  useEffect(() => {
    getRegionsList({ isPaginate: 1 });

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getProvinceList({ region_code: region.value, q: formData.keyword, isPaginate: 1 });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);
  return (
    <Route
      path={`${match.path}/:provinceId?`}
      render={({ match: { params } }) => (
        <div>
          <div className="card p-0 mb-3 mt-3">
            <div className="container-fluid  px-0">
              <div className="d-inline w-auto d-flex justify-content-start m-3">
                <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
                  Select Region:
                </label>
                <div style={{ width: 250 }}>
                  <Select
                    styles={customStyle}
                    placeholder="Select Region"
                    value={region}
                    options={createDropdown(regionsList)}
                    onChange={handleChangeSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          <GenericListPair
            moduleName="Province List"
            getData={getProvinceList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Province..."
            pathName={`${match.path}/:provinceId?`}
            listName="Province"
            label="Province"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.provinceId}
            data={provinceList}
            dataPager={provinceListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:provinceId?`}
                    render={() => (
                      <ProvinceContent />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:provinceId?`}
                  render={() =>
                    !params.provinceId && provinceList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(provinceList, '0.id')}`}
                      />
                    ) : (
                      <Redirect
                        to={`${match.url}/${_.get(provinceList, '0.id')}`}
                      />
                    )
                  }
                />
              </React.Fragment>
            )}
          />
        </div>
      )}
    />
  );
}

ProvinceContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  provinceListPager: PropTypes.instanceOf(Object).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_PROVINCE_LIST) > -1,
  provinceList: _.get(api, `${c.GET_PROVINCE_LIST}.list`) || [],
  provinceListPager: _.get(api, `${c.GET_PROVINCE_LIST}.pager`) || {},
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ProvinceContainer);
